export function _getSelection() {
  return window.getSelection() || null;
};
